import { render, staticRenderFns } from "./SalesTargets.vue?vue&type=template&id=447315a8&scoped=true"
import script from "./SalesTargets.vue?vue&type=script&lang=js"
export * from "./SalesTargets.vue?vue&type=script&lang=js"
import style0 from "./SalesTargets.vue?vue&type=style&index=0&id=447315a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447315a8",
  null
  
)

export default component.exports